type RealtimeLogCategory = 'connection_error' | 'protocol_error' | 'mapping_error' | 'render_error'

export interface RealtimeLogEntry {
  category: RealtimeLogCategory
  message: string
  detail?: unknown
  timestamp: number
}

export type RealtimeLogHandler = (entry: RealtimeLogEntry) => void

let logHandler: RealtimeLogHandler | null = null

export function setRealtimeLogHandler(handler: RealtimeLogHandler | null) {
  logHandler = handler
}

const LOG_BUFFER_MAX = 200
const logBuffer: RealtimeLogEntry[] = []
const logListeners = new Set<() => void>()

/** 供底部「事件日志」等订阅；返回取消函数 */
export function subscribeRealtimeLog(listener: () => void): () => void {
  logListeners.add(listener)
  return () => logListeners.delete(listener)
}

export function getRealtimeLogBuffer(): readonly RealtimeLogEntry[] {
  return logBuffer
}

function notifyLogListeners() {
  for (const fn of logListeners) fn()
}

export function logRealtime(category: RealtimeLogCategory, message: string, detail?: unknown) {
  const entry: RealtimeLogEntry = { category, message, detail, timestamp: Date.now() }
  logBuffer.push(entry)
  if (logBuffer.length > LOG_BUFFER_MAX) logBuffer.shift()
  notifyLogListeners()
  logHandler?.(entry)
  const prefix = `[realtime:${category}]`
  if (detail !== undefined) console.warn(prefix, message, detail)
  else console.warn(prefix, message)
}
